import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { syncChartDirection } from "@/components/charts/chartSetup";
import ar from "./locales/ar.json";
import en from "./locales/en.json";

export type Lang = "ar" | "en";

export const supportedLngs: Lang[] = ["ar", "en"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    fallbackLng: "ar",
    supportedLngs,
    // The app is Arabic-first / RTL by default. Detect ONLY a previously-stored
    // explicit choice; with empty localStorage we fall back to "ar" rather than
    // the browser language (which would boot a non-Arabic browser into English +
    // LTR, contradicting the documented default). [audit P0-2]
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "sij_lang",
    },
  });

function applyDirection(lng: string) {
  const dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);
}

applyDirection(i18n.language || "ar");
i18n.on("languageChanged", (lng) => {
  applyDirection(lng);
  syncChartDirection();
});

export default i18n;
